/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { DATA_UNAVAILABLE } from '../../utils/utils';
import { FilterChipProps } from './SelectedFiletrsPanel';

export const deleteFilterViaChipsDeletion = <T extends object>(chipsProps: FilterChipProps<T>, filterParams: T): T => {
    const newFilterParams: T = { ...filterParams };
    if (Array.isArray(newFilterParams[chipsProps.keyForValue])) {
        if (Object.keys(chipsProps).includes('index')) {
            (newFilterParams[chipsProps.keyForValue] as Array<unknown>).splice(chipsProps.index, 1);
        }
    } else {
        if (Object.keys(chipsProps).includes('resetValue'))
            Reflect.set(newFilterParams, chipsProps.keyForValue, chipsProps.resetValue);
        else newFilterParams[chipsProps.keyForValue] = null;
        if (Object.keys(chipsProps).includes('pairedKeyForValue')) newFilterParams[chipsProps.pairedKeyForValue] = null;
    }
    return newFilterParams;
};

export const makeChipTextForRangeFilter = (
    prefix: string,
    fromValue: string | number,
    toValue: string | number,
): string => {
    if (fromValue === null && toValue === null) return DATA_UNAVAILABLE;
    if (fromValue !== null && toValue === null) return `${prefix}: ≥ ${fromValue}`;
    if (fromValue === null && toValue !== null) return `${prefix}: ≤ ${toValue}`;
    if (fromValue === toValue) return `${prefix}: ${fromValue}`;

    return `${prefix}: ${fromValue ? fromValue : 0} - ${toValue ? toValue : 0}`;
};
